import { getTableHeightFitContent } from 'helpers/lib/reactDataGridHelpers';
import { get } from 'lodash';
import React, { useCallback, useEffect, useState } from 'react';
import ReactDataGrid from 'react-data-grid';

const EmptyRowsView = () => {
    const message = 'Chưa có tháng nào';
    return (
        <div style={{ textAlign: 'center', backgroundColor: '#ddd', padding: '100px', height: '100%' }}>
            <h3>{message}</h3>
        </div>
    );
};

function NunByMonthList({ numberOfNuns, setData }) {
    const [rows, setRows] = useState([]);
    const [columns, setColumns] = useState([]);

    const [tableHeight, setTableHeight] = useState();
    useEffect(() => {
        setTableHeight(getTableHeightFitContent());
    }, []);

    const onGridRowsUpdated = ({ fromRow, toRow, updated }) => {
        const newRows = [...rows];
        for (let i = fromRow; i <= toRow; i++) {
            newRows[i] = { ...newRows[i], ...updated };
        }
        setRows(newRows);
        setData(newRows);
    };

    useEffect(() => {
        setColumns([
            { key: 'month', name: 'Tháng', width: 150 },
            { key: 'numberOfNuns', name: 'Số lượng sơ', editable: true, width: 120 },
        ]);
    }, []);

    const getNumberOfNuns = useCallback(
        (month) => {
            switch (month) {
                case 1:
                    return get(numberOfNuns, 'janAmount');
                case 2:
                    return get(numberOfNuns, 'febAmount');
                case 3:
                    return get(numberOfNuns, 'marAmount');
                case 4:
                    return get(numberOfNuns, 'aprAmount');
                case 5:
                    return get(numberOfNuns, 'mayAmount');
                case 6:
                    return get(numberOfNuns, 'junAmount');
                case 7:
                    return get(numberOfNuns, 'julAmount');
                case 8:
                    return get(numberOfNuns, 'augAmount');
                case 9:
                    return get(numberOfNuns, 'sepAmount');
                case 10:
                    return get(numberOfNuns, 'octAmount');
                case 11:
                    return get(numberOfNuns, 'novAmount');
                case 12:
                    return get(numberOfNuns, 'decAmount');

                default:
                    return '';
            }
        },
        [numberOfNuns]
    );

    useEffect(() => {
        const rows = [];
        [...Array(12).keys()].forEach((index) => {
            const row = {
                month: index + 1,
                numberOfNuns: getNumberOfNuns(index + 1),
            };
            rows.push(row);
        });
        setRows(rows);
    }, [getNumberOfNuns]);

    return (
        <div id="rdg">
            <ReactDataGrid
                columns={columns}
                rowGetter={(i) => rows[i]}
                rowsCount={rows.length}
                minHeight={tableHeight}
                onGridRowsUpdated={onGridRowsUpdated}
                enableCellSelect={true}
                headerRowHeight={60}
                emptyRowsView={EmptyRowsView}
            />
        </div>
    );
}

export default NunByMonthList;
